// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DestinationsRouteImport } from './routes/destinations'
import { Route as OkazjeRouteImport } from './routes/okazje'
import { Route as PolitykaPrywatnosciRouteImport } from './routes/polityka-prywatnosci'
import { Route as RegulaminRouteImport } from './routes/regulamin'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TanieLotyRouteImport } from './routes/tanie-loty'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as GdziekolwiekIndexRouteImport } from './routes/gdziekolwiek.index'
import { Route as GdziekolwiekFromRouteImport } from './routes/gdziekolwiek.$from'
import { Route as LotyIndexRouteImport } from './routes/loty.index'
import { Route as LotyCityRouteImport } from './routes/loty.$city'
import { Route as LotyFromToRouteImport } from './routes/loty.$from.$to'
import { Route as LotyKrajSlugRouteImport } from './routes/loty.kraj.$slug'
import { Route as LotyTematSlugRouteImport } from './routes/loty.temat.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DestinationsRoute = DestinationsRouteImport.update({
            id: '/destinations',path: '/destinations',getParentRoute: () => rootRouteImport
          })
const OkazjeRoute = OkazjeRouteImport.update({
            id: '/okazje',path: '/okazje',getParentRoute: () => rootRouteImport
          })
const PolitykaPrywatnosciRoute = PolitykaPrywatnosciRouteImport.update({
            id: '/polityka-prywatnosci',path: '/polityka-prywatnosci',getParentRoute: () => rootRouteImport
          })
const RegulaminRoute = RegulaminRouteImport.update({
            id: '/regulamin',path: '/regulamin',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const TanieLotyRoute = TanieLotyRouteImport.update({
            id: '/tanie-loty',path: '/tanie-loty',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const GdziekolwiekIndexRoute = GdziekolwiekIndexRouteImport.update({
            id: '/gdziekolwiek/',path: '/gdziekolwiek/',getParentRoute: () => rootRouteImport
          })
const GdziekolwiekFromRoute = GdziekolwiekFromRouteImport.update({
            id: '/gdziekolwiek/$from',path: '/gdziekolwiek/$from',getParentRoute: () => rootRouteImport
          })
const LotyIndexRoute = LotyIndexRouteImport.update({
            id: '/loty/',path: '/loty/',getParentRoute: () => rootRouteImport
          })
const LotyCityRoute = LotyCityRouteImport.update({
            id: '/loty/$city',path: '/loty/$city',getParentRoute: () => rootRouteImport
          })
const LotyFromToRoute = LotyFromToRouteImport.update({
            id: '/loty/$from/$to',path: '/loty/$from/$to',getParentRoute: () => rootRouteImport
          })
const LotyKrajSlugRoute = LotyKrajSlugRouteImport.update({
            id: '/loty/kraj/$slug',path: '/loty/kraj/$slug',getParentRoute: () => rootRouteImport
          })
const LotyTematSlugRoute = LotyTematSlugRouteImport.update({
            id: '/loty/temat/$slug',path: '/loty/temat/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,DestinationsRoute: DestinationsRoute,OkazjeRoute: OkazjeRoute,PolitykaPrywatnosciRoute: PolitykaPrywatnosciRoute,RegulaminRoute: RegulaminRoute,SearchRoute: SearchRoute,TanieLotyRoute: TanieLotyRoute,AdminLoginRoute: AdminLoginRoute,BlogSlugRoute: BlogSlugRoute,GdziekolwiekFromRoute: GdziekolwiekFromRoute,LotyCityRoute: LotyCityRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,GdziekolwiekIndexRoute: GdziekolwiekIndexRoute,LotyIndexRoute: LotyIndexRoute,LotyFromToRoute: LotyFromToRoute,LotyKrajSlugRoute: LotyKrajSlugRoute,LotyTematSlugRoute: LotyTematSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)